<template>
    <div class="buy-popup-wrapper"  v-show="show.isShow" v-if="Array.isArray(showPackageList) && showPackageList.length">
        <transition>
            <div class="buy-popup-masker" @click="close"></div>
        </transition>
        <transition name="slideup">
            <div class="buy-popup-wrap" v-show="show.isShow">
                <div class="detail_purchase">
                    <span class="closeBtn" @click="close"></span>
                    <div class="detail_goods_info">
                        <img :src="coverPic" class="goods_small" v-if="coverPic" >
                        <div class="salePrice" v-if="isGroupBuying">
                            <em>拼团价 </em>¥<em class="priceText">{{selectedPackageId ? selectedPackage.groupInfo && selectedPackage.groupInfo.newProductPrice : `${groupStartPrice}起`}}</em>
                            <span class="stockLabel">(库存:{{selectedPackage.adultStock}})</span>
                        </div>
                        <div class="salePrice" v-else-if="!selectedPackageId">¥<em class="priceText">{{head && head.price && head.price.startPrice}}</em>起</div>
                        <div class="salePrice" v-else>¥<em class="priceText">{{selectedPackage.adultPrice}}</em><span class="stockLabel">(库存:{{selectedPackage.adultStock}})</span></div>
                        <div class="goods_stock" v-if="selectedPackageId">已选：<span>{{selectedPackage.packageName}}</span></div>
                    </div>
                    <div class="module_box">
                        <div class="purchase_mod">
                            <h3>套餐<span class="tips-limit">{{otherLimitTips}}</span></h3>
                            <div class="purchase_mod_con">
                                <div class="inner">
                                    <span :class="{'selected': item.packageId === selectedPackageId, 'disabled': item.adultStock <= 0}" v-for="(item) in showPackageList" :key="item.packageId" @click="selectPackage(item)">{{item.packageName | ellipsis}}</span>
                                </div>
                            </div>
                            <div class="purchase_msg" v-if="specification&&priceUnit">
                                <div class="inner">
                                    <span>规<span style="color:white">空格</span>格</span>:&nbsp;&nbsp;<span>{{specification}}</span>
                                </div>
                                <div class="inner">
                                    <span>计价单位</span>:&nbsp;&nbsp;<span>{{priceUnit}}</span>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="purchase_count">
                        <span class="purchase_label">数量<span class="tips-limit">{{buyCountLimitTips}}</span></span>
                        <div class="purchase_num">
                            <number-select
                                :value="packageBuyCount"
                                :min="min"
                                :max="max"
                                @change="changeBuyCount"
                                ></number-select>
                        </div>
                    </div>
                    <!-- <div :class="{'purchaseBtn': true, 'disabled': !canBuy}" @click="goToOrder">确定</div> -->
                    <div :class="{'purchaseBtn': true, 'disabled': !canBuy}">
                        <div class="submit-group" v-if="showAllBtnAndPoster && (baseInfo.classBrandParentId === 56 || baseInfo.prdTmpId === 8)">
                            <div class="left" @click="goToOrder(1)">自购</div>
                            <div class="right" @click="goToOrder(2)">代客订</div>
                        </div>
                        <div class="submit" v-else @click="goToOrder(1)">立即预订</div>
                    </div>

                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import derivativePackageStoreModule from '../store/modules/derivativePackage';
import NumberSelect from '@/components/NumberSelect';
const { resizeImage } = require('@tuniu/light-helper');
import { eventTrack } from '@/business/analy';
import { versionCmp } from '@/business/global';
import { mapGetters } from 'vuex';
import storage from '@/util/storage';
import { bookCheckP } from 'create-api';
const LOGIN_URL = '/u/login';

export default {
    name: 'packagePopup',
    props: {
        show: {
            type: Object,
            default: {
                isShow: false
            }
        },
        image: {
            type: Object,
            default: function () {
                return {}
            }
        },
        head: {
            type: Object,
            default: function () {
                return {}
            }
        },
        productId: {
            type: Number,
            default: function () {
                return 0
            }
        },
        isGroupBuying: {
          type: Boolean,
          default: false
        },
        groupActivity: {
          type: Object,
          default: () => ({})
        },
        showAllBtnAndPoster: {
            type: Boolean,
            default: false
        }
    },
    components: {
        NumberSelect
    },
    data(){
        return {
            specification:'',//规格
            priceUnit:'',//计价单位
        }
    },
    created () {
        // if (!this.$store.state.derivativePackage || !this.$store.state.derivativePackage.packageList.length) {
        //     this.$store.registerModule('derivativePackage', derivativePackageStoreModule);
        // }
        // if (typeof window !== 'undefined') {
        //     if (this.productId) {
        //         this.$store.dispatch('derivativePackage/getPackageList', {
        //             productId: this.productId
        //         });
        //     }
        // }
    },
    updated () {
        // let defaultPackage = this.showPackageList.find(item => item.adultStock)
        // if (defaultPackage) {
        //     this.selectPackage(defaultPackage)
        // }
    },
    destroyed () {
        // this.$store.unregisterModule('package')
    },
    computed: {
        ...mapGetters('derivativePackage', [
            'groupPackageList',
            'groupStartPrice'
        ]),
        baseInfo() {
            return (this.$store.state.detail && this.$store.state.detail.baseInfo) || {};
        },
        coverPic () {
            if (this.image && this.image.productImageList && this.image.productImageList[0] && this.image.productImageList[0].imageUrl){
                return resizeImage(this.image.productImageList[0].imageUrl, 180, 180, 1)
            } else {
                return ''
            }
        },
        packageList () {
            return this.$store.state.derivativePackage.packageList || [];
        },
        showPackageList () {
            return this.isGroupBuying ? this.groupPackageList : this.packageList;
        },
        isLogin () {
            return this.$store.state.derivativePackage.isLogin;
        },
        selectedPackageId () {
            return this.$store.state.derivativePackage.selectedPackageId || 0;
        },
        packageBuyCount () {
            return this.$store.state.derivativePackage.packageBuyCount || 1;
        },
        selectedPackage () {
            return (this.selectedPackageId && this.showPackageList.find(el => el.packageId === this.selectedPackageId)) || {};
        },
        max () {
            let maxArr = [];
            maxArr.push(this.selectedPackage.adultStock);
            if(this.selectedPackage){
                if (this.isGroupBuying && this.selectedPackage.groupInfo && this.selectedPackage.groupInfo.purchaseLimit) {
                    maxArr.push(this.selectedPackage.groupInfo.joinTime);
                }
                if (this.selectedPackage.adultNumMax) {
                    maxArr.push(this.selectedPackage.adultNumMax);
                }
            }
            return Math.min(...maxArr);
        },
        min () {
            return this.selectedPackage.adultNumMin || 1;
        },
        buyCountLimitTips () {
            if (this.min > this.max) {
                return '（套餐暂时无法预定，请联系商家）'
            }
            let tips = [];
            let limitType = this.selectedPackage.bookLimit && this.selectedPackage.bookLimit.type;
            let groupLimit = this.isGroupBuying && this.selectedPackage.groupInfo && this.selectedPackage.groupInfo.purchaseLimit && this.selectedPackage.groupInfo.joinTime || Infinity;
            let adultNumMax = this.selectedPackage.adultNumMax || Infinity;
            let adultNumMin = this.selectedPackage.adultNumMin;
            if (limitType === 1 && adultNumMax !== Infinity) {
                tips.push(`每个会员ID限购${adultNumMax}件`);
                if (adultNumMax > groupLimit) {
                    tips.unshift(`每订单限购${groupLimit}件`);
                }
            } else if (limitType === 0) {
                if (adultNumMin > 1) tips.push(`${adultNumMin}件起购`);
                let max = Math.min(groupLimit, adultNumMax);
                if (max !== Infinity) tips.push(`限购${max}件`);
            } else if (groupLimit !== Infinity) {
                tips.push(`限购${groupLimit}件`);
            }
            tips = tips.join('，');
            return tips && `（${tips}）`;
        },
        otherLimitTips () {
            let tips = [];
            if (this.selectedPackage.firstOrderLimit === 1) {
                tips.push('途牛会员首次消费');
            }
            if (this.selectedPackage.fabLevelLimit && this.selectedPackage.fabLevelLimit.length) {
                tips.push(this.selectedPackage.fabLevelLimit.map(val => val.name.replace('会员', '')).join('、') + '会员');
            }
            tips = tips.join('，');
            return tips && `（此套餐仅限${tips}购买）`;
        },
        canBuy () {
            return this.selectedPackageId && this.packageBuyCount >= this.min && this.packageBuyCount <= this.max;
        }
    },
    watch: {
        'show.isShow' (val) {
            if (val) {
                this.changeBuyCount(this.min);
                this.fixedBody();
            } else {
                this.looseBody();
            }
        },
        showPackageList: {
            handler (val) {
                let defaultPackage = val.find(item => item.adultStock)
                if (defaultPackage) {
                    this.selectPackage(defaultPackage)
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        fixedBody () {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            document.body.style.position = 'fixed';
            document.body.style.width="100%";
            document.body.style.top = `-${scrollTop}px`;
        },
        looseBody () {
            let top = document.body.style.top;
            document.body.style.position = 'static';
            document.body.style.top = '';
            window.scrollTo(0, -parseInt(top));
        },
        selectPackage (item) {
            item.extensionAttrList.forEach(attr => {
                if(attr.attrName == 'priceUnit'){
                    this.priceUnit = attr.attrValue
                }
                if(attr.attrName == 'spec'){
                    this.specification = attr.attrValue
                }
            })
            if (item.adultStock) {
                this.$store.dispatch('derivativePackage/selectPackage', {
                    packageId: item.packageId
                });
            }
        },
        changeBuyCount (count) {
            this.$store.dispatch('derivativePackage/changePackageBuyCount', {
                count
            });
        },
        close () {
            this.show.isShow = false;
        },
        goToOrder (createType) {
            if (!this.canBuy) return
            
            if (this.selectedPackageId && this.packageBuyCount) {
                eventTrack('CLICK_INDEX_POPUP_SUBMIT');
                this.close();
                if (this.isLogin) {
                    bookCheckP({
                        productId: this.productId,
                        pkgId: this.selectedPackageId,
                        adultNum: this.packageBuyCount,
                        childNum: 0
                    }).then(res => {
                        if (res.success) {
                            let url = '/item/' + this.productId;
                            if (this.baseInfo.prdTmpId === 3) {
                                // 代客订的百货类产品，在苔客app时跳转到app代客订页面
                                if (2 === createType && this.baseInfo.isTekApp && window.G && window.G.webviewBridgeReady) {
                                    let that = this;
                                    window.G.webviewBridgeReady(function(bridge) {
                                        bridge.callHandler('getAppVersion', {}, function (json) {
                                            if(json && json.data && json.data.version && versionCmp(json.data.version, '3.6.0') >= 0) {
                                                let params = {
                                                    rctModuleName: "book",
                                                    rctModule: "tekrndetail",
                                                    rctModuleParams: {
                                                        productId: that.productId,
                                                        packageId: that.selectedPackageId,
                                                        count: that.packageBuyCount
                                                    }
                                                };
                                                window.location.href = `tntweeker://page?iosPageName=TNReactNativeViewController&androidPageName=com.tuniu.tweeker.rn.TNReactNativeActivity&parameters=${encodeURIComponent(JSON.stringify(params))}`;
                                            }
                                        })
                                    })
                                } else {
                                    url += '/buy';
                                }
                            } else {
                                url += '/book';
                                let orderBaseInfo = {
                                    adult: this.packageBuyCount,
                                    child: 0,
                                    room: 0,
                                    dateData: Object.assign({}, this.selectedPackage.priceCalendarList[0]),
                                    pkg: this.selectedPackage
                                };
                                storage.save({
                                    baseInfo: {
                                        productId: this.baseInfo.productId,
                                        productName: this.baseInfo.productName,
                                        priceTemplate: this.baseInfo.priceTemplate,
                                        shopId: this.baseInfo.otherInfo && this.baseInfo.otherInfo.shop && this.baseInfo.otherInfo.shop.shopId,
                                        journeyDays: this.baseInfo.journeyDays,
                                        journeyNights: this.baseInfo.journeyNights,
                                        hasCustomAttr: this.baseInfo.hasCustomAttr,
                                        destinationCode: this.baseInfo.destinationCode,
                                        destinationName: this.baseInfo.destinationName,
                                        isSecondSure: this.baseInfo.head && this.baseInfo.head.isSecondSure,
                                        bookCityCode: this.baseInfo.bookCityCode,
                                        isApp: this.baseInfo.isApp,
                                        prdTmpId: this.baseInfo.prdTmpId,
                                        contractTemplate: this.baseInfo.contractTemplate
                                    },
                                    orderBaseInfo,
                                    createType
                                })
                            }
                            if (this.isGroupBuying) {
                                url += '?groupId=0';
                            }
                            this.$router.push(this.getAppLink(url));
                        } else {
                            this.$easyToast(res.msg, {
                                duration: 2000
                            })
                        }
                    })
                } else {
                    let groupActivityData = this.baseInfo.groupActivity;
                    let _pValue = groupActivityData && groupActivityData.custPValue || 0;
                    let _LOGIN_URL = this.isGroupBuying ? LOGIN_URL + `?pValue=${_pValue}` : LOGIN_URL;
                    console.log("_LOGIN_URL===",_pValue,_LOGIN_URL);
                    window.location.href = _LOGIN_URL + '?urlRefer=' + window.btoa(encodeURI((window.app_url && window.app_url('') || '') + '/item/' + this.$route.params.id))
                }

            } else {
                this.$easyToast('请选择套餐', {
                    duration: 2000,
                    horizontalPosition: 'center',
                    verticalPosition: 'center'
                });
            }
        }
    },
    filters: {
        ellipsis: function(value) {
            if (value && value.length > 20) {
                return value.substr(0, 20) + '…';
            } else {
                return value
            }
        }
    }
};
</script>

<style lang="scss">
.buy-popup-wrapper {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 99;
}
.buy-popup-masker {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);
    z-index: 100;
    touch-action: manipulation;
}
.buy-popup-wrap {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 101;
    background: #fff;
    border-top-left-radius: 18px;
    border-top-right-radius: 18px;
}
.detail_purchase {
    .closeBtn {
        position: absolute;
        right: 10px;
        top: 10px;
        width: 32px;
        height: 32px;
        z-index: 102;
        touch-action: manipulation;
        &:before, &:after {
            content: " ";
            position: absolute;
            top: 50%;
            left: 20%;
            width: 60%;
            height: 2px;
            background: #bbb;
            transform: rotate(45deg);
        }
        &:after {
            transform: rotate(-45deg);
        }
    }
    .detail_goods_info {
        position: relative;
        min-height: 50px;
        padding: 20px 0 15px 112px;
        border-bottom: 1px solid rgba(0,0,0,0.08);
        margin: 0 0 5px;
    }
    .salePrice {
        line-height: 20px;
        font-size: 18px;
        margin-bottom: 5px;
        color: #ff6436;
        .priceText {
            font-family: DINAlternate-Bold;
        }
        & > span {
            font-size: 14px;
            color: #666;
            padding: 0 0 0 10px;
        }
    }
    .goods_stock {
        font-family: PingFang-SC-Regular;
        font-size: 13px;
        color: #777893;
        line-height: 14px;
        word-break: break-all;
    }
    .goods_small {
        position: absolute;
        left: 12px;
        top: -20px;
        width: 90px;
        height: 90px;
        padding: 1px;
        box-shadow: 0 0 0 1px #e5e5e5 inset;
        box-sizing: border-box;
        background-color: #fff;
        border-radius: 9px;
    }
    .purchase_mod {
        padding: 0 12px;
        max-height: 150px;
        overflow: auto;
        h3 {
            font-size: 14px;
            margin-bottom: 12px;
            font-family: PingFang-SC-Regular;
            color: #383838;
            .tips-limit {
                font-size: 13px;
                color: #777893;
            }
        }
        .purchase_mod_con {
            overflow: hidden;
            font-size: 0;
            span {
                display: inline-block;
                border: 1px solid #f6f6f6;
                font-family: PingFang-SC-Regular;
                font-size: 12px;
                line-height: 12px;
                text-align: center;
                border-radius: 9px;
                color: #383838;
                margin: 0 6px 6px 0;
                padding: 9px 14px;
                box-sizing: border-box;
                touch-action: manipulation;
            }
            .disabled {
                color: #999;
                border-color: #e5e5e5;
            }
            .selected {
                color: #32c45e;
                border-color: #32c45e;
                background: #ECFBF0;
            }
        }
    }
    .purchase_count {
        position: relative;
        padding: 10px 0 40px 12px;
        .purchase_label {
            font-size: 14px;
            line-height: 38px;
            font-family: PingFang-SC-Regular;
            color: #383838;
            margin-bottom: 10px;
            &.disabled {
                background: #999;
            }
            .tips-limit {
                font-size: 13px;
                color: #777893;
            }
        }
        .purchase_num {
            width: 96px;
        }
    }
    .purchaseBtn {
        text-align: center;
        font-size: 16px;
        line-height: 44px;
        background-color: #32c45d;
        margin: 0 30px 8px;
        border-radius: 22px;
        color: #fff;
        touch-action: manipulation;
        &.disabled {
            background-color: #999;
            border-color: #e5e5e5;
            .submit-group {
                .left {
                    background: #999;
                    border-color: #e5e5e5;
                    color: #fff;
                    border-right:1px solid #fff;
                }
                .right {
                    background: #999;
                    border-color: #e5e5e5;
                    color: #fff;
                }
            }
        }
        .submit-group {
            display: flex;
            .left {
                flex: 1;
                background: #E6F8EA;
                color: #32c45d;
                border-radius: 20px 0 0 20px;
            }
            .right {
                flex: 1;
                background: #32c45d;
                color: #fff;
                border-radius: 0 20px 20px 0;
            }
        }

    }
}
.slideup-enter-active {
  transition: all .25s ease;
}
.slideup-leave-active {
  transition: all .25s ease;
}
.slideup-enter, .slideup-leave-to {
  transform: translateY(1000px);
}
.purchase_msg{
    font-size: 14px;
    padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// PackagePopup.vue